import { InputMask } from "@react-input/mask";
import FieldValidationError from "../Forms/Element/FieldValidationError";

const CnpjInput = (props) => {

    return (
        <>
            <InputMask
                mask="__.___.___/____-__"
                replacement={{ _: /\d/ }}
                className="form-control input-default"
                {...props}
            />
            <FieldValidationError error={props.error} />
        </>
    )
}

export default CnpjInput;